import { useEffect } from 'react';
import { api } from '../../services/api';

const VISIT_SESSION_KEY = 'od_visit_session_id';

function visitSessionId() {
  try {
    const existing = localStorage.getItem(VISIT_SESSION_KEY);
    if (existing && existing.length >= 12) return existing;
    const next = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(VISIT_SESSION_KEY, next);
    return next;
  } catch {
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  }
}

export default function useSiteVisitTracking(location, language) {
  useEffect(() => {
    const pathname = location.pathname || '/';
    if (pathname.startsWith('/admin') || pathname.startsWith('/api')) return;

    const payload = {
      session_id: visitSessionId(),
      path: `${pathname}${location.search || ''}`.slice(0, 512),
      title: document.title || '',
      referrer: document.referrer || '',
      language,
    };

    const body = JSON.stringify(payload);
    const url = `${api.apiUrl || ''}/api/site-visits`;
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }

    api.trackVisit(payload).catch(() => {});
  }, [language, location.pathname, location.search]);
}
